import React, {useMemo, useEffect} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Topbar} from "./Topbar";
import {Brand} from "../brand/Brand";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";

export function Header() {
  const uiService = useHtmlClassService();

  // Keep a CSS variable with the current header height so the subheader can sit below it
  useEffect(() => {
    const headerEl = document.getElementById("kt_header");
    if (!headerEl) return;

    const updateHeaderHeightVar = () => {
      const rect = headerEl.getBoundingClientRect();
      const computed = window.getComputedStyle(headerEl);
      const marginBottom = parseFloat(computed.marginBottom || "0");
      const height = rect.height + marginBottom;
      document.documentElement.style.setProperty("--header-height", `${Math.round(height)}px`);
    };

    // Run an extra settle loop to catch immediate wraps after layout changes
    const settleHeightVar = () => {
      let frames = 6; // ~100ms at 60fps
      const tick = () => {
        updateHeaderHeightVar();
        if (--frames > 0) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    updateHeaderHeightVar();
    settleHeightVar();

    const ro = new ResizeObserver(() => settleHeightVar());
    try { ro.observe(headerEl); } catch (e) {}

    // Observe inner container as wraps often occur there
    const container = headerEl.querySelector(".container, .container-fluid");
    if (container) {
      try { ro.observe(container); } catch (e) {}
    }

    // Mutation observer for text/icon changes that affect height
    const mo = new MutationObserver(() => settleHeightVar());
    try { mo.observe(headerEl, { childList: true, subtree: true, characterData: true }); } catch (e) {}

    window.addEventListener("resize", updateHeaderHeightVar);
    window.addEventListener("orientationchange", updateHeaderHeightVar);
    window.addEventListener("load", updateHeaderHeightVar);

    return () => {
      try { ro.disconnect(); } catch (e) {}
      try { mo.disconnect(); } catch (e) {}
      window.removeEventListener("resize", updateHeaderHeightVar);
      window.removeEventListener("orientationchange", updateHeaderHeightVar);
      window.removeEventListener("load", updateHeaderHeightVar);
    };
  }, []);

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        
          <AnimateLoading />
          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
          <div className="header-container">
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}
            </div>
          
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
